import { makeAutoObservable } from 'mobx'

import { CreateObjectDraftResponse } from 'shared/api/kyrgyzstan/create-object'

export const createObjectMockDraft: CreateObjectDraftResponse = {
  id: '95db7de6-0b90-4429-a8fd-2e4c9eb9b628',
  realty_type_id: 1,
  status: '',
  status_label: '',
  current_step: 'photos',
  listing_mode: 'single_object',
  can_open_children: false,
}

export class CreateObjectStore {
  draft: CreateObjectDraftResponse | null

  constructor(initialDraft: CreateObjectDraftResponse | null = null) {
    this.draft = initialDraft

    makeAutoObservable(this)
  }

  get draftId() {
    return this.draft?.id ?? null
  }

  setDraft = (draft: CreateObjectDraftResponse) => {
    this.draft = draft
  }

  reset = () => {
    this.draft = null
  }
}

export const createObjectSessionStore = new CreateObjectStore()
